var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 630.339,
    height: 376.826,
    viewBox: "0 0 630.339 376.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_Login_re_4vu2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95",
    "data-name": "Trazado 95",
    d: "M826.571,658.318c-8.07-6.819-12.972-17.591-11.686-28.078s9.248-20.127,19.576-22.354,22.1,3.938,25.238,14.026c1.726-19.451,3.716-39.717,14.057-56.281,9.364-15,25.582-25.731,43.159-27.651s36.084,5.331,47.046,19.2,13.646,34.042,5.969,49.97c-5.656,11.733-16.076,20.466-26.993,27.57a174.214,174.214,0,0,1-119.151,26.067Z",
    transform: "translate(-343.969 -285.724)",
    fill: "#43a854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_96",
    "data-name": "Trazado 96",
    d: "M964.565,545.858A287.461,287.461,0,0,0,880.1,660.07c-.806,1.974,2.4,2.834,3.2.881A284.264,284.264,0,0,1,966.909,548.2c1.655-1.348-.7-3.681-2.344-2.344Z",
    transform: "translate(-361.955 -287.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97",
    "data-name": "Trazado 97",
    d: "M367.916,638.629c11.084-9.366,17.817-24.162,16.051-38.565s-12.7-27.645-26.887-30.7-30.356,5.408-34.664,19.265c-2.371-26.716-5.1-54.551-19.308-77.3-12.861-20.6-35.137-35.341-59.279-37.978s-49.561,7.323-64.617,26.378-18.743,46.757-8.2,68.634c7.768,16.116,22.08,28.109,37.076,37.867a239.283,239.283,0,0,0,163.654,35.8",
    transform: "translate(-165 -267.888)",
    fill: "#43a854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98",
    "data-name": "Trazado 98",
    d: "M216.048,484.164a391.491,391.491,0,0,1,54.56,54.178,397.1,397.1,0,0,1,43.027,63.679,395.474,395.474,0,0,1,18.425,39.013c1.107,2.712-3.3,3.892-4.391,1.211a388.608,388.608,0,0,0-35.508-67.183,391.048,391.048,0,0,0-47.623-58.83,390.123,390.123,0,0,0-31.71-28.847c-2.273-1.851.965-5.056,3.22-3.22Z",
    transform: "translate(-177.962 -270.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_99",
    "data-name": "Trazado 99",
    d: "M688.953,565.961H424.5V294.625A104.813,104.813,0,0,1,529.194,189.931h55.065A104.813,104.813,0,0,1,688.953,294.625Z",
    transform: "translate(-236.485 -189.931)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_100",
    "data-name": "Trazado 100",
    d: "M633.888,565.962H424.5V294.626a103.884,103.884,0,0,1,19.994-61.545c.481-.656.961-1.3,1.455-1.943a104.67,104.67,0,0,1,22.282-21.628c.478-.348.958-.689,1.445-1.031a104.447,104.447,0,0,1,22.8-11.925c.479-.181.966-.363,1.454-.538a104.346,104.346,0,0,1,22.539-5.315c.477-.065.966-.116,1.455-.167a105.991,105.991,0,0,1,22.537,0c.488.051.977.1,1.459.168a104.326,104.326,0,0,1,22.533,5.314c.488.174.975.356,1.455.538A104.186,104.186,0,0,1,588.449,208.3c.487.334.974.676,1.454,1.018A105.776,105.776,0,0,1,603.222,220.6a104.558,104.558,0,0,1,9.219,10.542c.493.638.973,1.285,1.453,1.939a103.884,103.884,0,0,1,19.995,61.546Z",
    transform: "translate(-236.485 -189.932)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_23",
    "data-name": "Elipse 23",
    cx: 11.592,
    cy: 11.592,
    r: 11.592,
    transform: "translate(368.785 231.487)",
    fill: "#43a854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_101",
    "data-name": "Trazado 101",
    d: "M589.615,494.756h-8.883l-4.226-34.261h13.11Z",
    transform: "translate(-158.811 -126.853)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_102",
    "data-name": "Trazado 102",
    d: "M569.481,504.28h17.131v10.786H558.695a10.786,10.786,0,0,1,10.786-10.786Z",
    transform: "translate(-153.905 -138.915)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_103",
    "data-name": "Trazado 103",
    d: "M650.615,494.756h-8.883l-4.226-34.261h13.11Z",
    transform: "translate(-175.615 -126.853)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104",
    "data-name": "Trazado 104",
    d: "M630.481,504.28h17.131v10.786H619.7a10.786,10.786,0,0,1,10.786-10.786Z",
    transform: "translate(-170.709 -138.915)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105",
    "data-name": "Trazado 105",
    d: "M697.587,492.593a7.783,7.783,0,0,1,3.268-11.479l30.2-83.224L745.908,406l-34.477,79.532a7.826,7.826,0,0,1-13.845,7.062Z",
    transform: "translate(-311.343 -247.218)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_106",
    "data-name": "Trazado 106",
    d: "M809.983,512.244a7.783,7.783,0,0,1-2.1-11.749l-9.354-88.037,16.909.773,3.887,86.6a7.826,7.826,0,0,1-9.346,12.418Z",
    transform: "translate(-339.521 -251.231)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_24",
    "data-name": "Elipse 24",
    cx: 17.795,
    cy: 17.795,
    r: 17.795,
    transform: "translate(425.693 99.668)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107",
    "data-name": "Trazado 107",
    d: "M793.782,484.844H740.133l.065-.417c.1-.624,9.561-62.628,2.581-82.912a8.559,8.559,0,0,1,4.4-10.566h0c9.978-4.7,29.131-10.485,45.3,3.557a20.457,20.457,0,0,1,6.854,16.951Z",
    transform: "translate(-323.433 -243.853)",
    fill: "#5b69e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108",
    "data-name": "Trazado 108",
    d: "M745.171,433.224l-24.153-4.9L732.34,401.5a10.141,10.141,0,1,1,19.639,5.07Z",
    transform: "translate(-318.167 -246.115)",
    fill: "#5b69e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    "data-name": "Trazado 109",
    d: "M796.422,443.037l-1.452-33.286c-1.1-6.257,2.481-12.172,7.99-13.139s10.891,3.376,12,9.68l5.458,31.1Z",
    transform: "translate(-338.484 -246.829)",
    fill: "#5b69e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    "data-name": "Trazado 110",
    d: "M790.9,517.049c8.632,32.877,9.574,74.676,7.245,120.272l-11.592-1.449-21.011-86.943-11.592,88.392-13.041-.725c-3.9-47.84-7.69-88.91-1.449-115.924Z",
    transform: "translate(-322.334 -280.042)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    "data-name": "Trazado 111",
    d: "M780.708,355.922c-3.32,3.536-9.485,1.638-9.918-3.193a5.835,5.835,0,0,1,.007-1.127c.223-2.14,1.46-4.083,1.164-6.342a3.324,3.324,0,0,0-.609-1.557c-2.646-3.542-8.855,1.584-11.352-1.622-1.531-1.966.269-5.062-.906-7.26-1.551-2.9-6.143-1.47-9.023-3.058-3.2-1.767-3.013-6.684-.9-9.674,2.573-3.647,7.083-5.593,11.537-5.873s8.878.924,13.036,2.544c4.725,1.841,9.41,4.386,12.318,8.54,3.536,5.052,3.876,11.845,2.108,17.752C787.09,348.644,783.419,353.034,780.708,355.922Z",
    transform: "translate(-325.495 -224.707)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_113",
    "data-name": "Trazado 113",
    d: "M596.4,516.963H502.209a4.684,4.684,0,0,1-4.709-4.648V302.079a4.684,4.684,0,0,1,4.709-4.648H596.4a4.684,4.684,0,0,1,4.709,4.648V512.314A4.684,4.684,0,0,1,596.4,516.963Z",
    transform: "translate(-256.594 -219.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_42",
    "data-name": "Rect\\xE1ngulo 42",
    width: 103.608,
    height: 1.449,
    transform: "translate(240.906 145.913)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_43",
    "data-name": "Rect\\xE1ngulo 43",
    width: 103.608,
    height: 1.449,
    transform: "translate(241.268 228.589)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_44",
    "data-name": "Rect\\xE1ngulo 44",
    width: 1.449,
    height: 220.257,
    transform: "translate(273.509 77.887)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_45",
    "data-name": "Rect\\xE1ngulo 45",
    width: 1.449,
    height: 220.257,
    transform: "translate(309.736 77.887)",
    fill: "#ccc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.cf55a318.svg";
export { ForwardRef as ReactComponent };